import { apiClient } from "lib/apiClient";

export const deleteMarketAreas = async (ids: string[]): Promise<void> => {
  await apiClient.delete("/market-areas", { data: ids });
};
